import { useEffect } from 'react';

const useViewportHeight = () => {
  useEffect(() => {
    // Function to set the --vh custom property
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Set the initial value
    setVh();

    // Update the value on resize
    window.addEventListener('resize', setVh);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);
};

export default useViewportHeight; 